<div class="chat-action-card" role="region" aria-live="polite">
  <h5>{{ 'chatAi.action.confirmTitle' | translate }}</h5>
  <p *ngIf="toolName"><strong>{{ toolName }}</strong></p>
  <p *ngIf="summary">{{ summary }}</p>
  <p class="chat-action-card__note">{{ 'chatAi.action.phase2Note' | translate }}</p>
</div>
